import React from 'react';
import cx from 'classnames';
import { IconButton, makeStyles } from '@material-ui/core';
import { Colors, ScriptPathTypesV2 } from 'typings';
import CheckIcon from '@material-ui/icons/CheckRounded';
import ExpandLessIcon from '@material-ui/icons/ExpandLessRounded';
import ExpandMoreIcon from '@material-ui/icons/ExpandMoreRounded';

interface ScriptStepToggleProps {
  isCollapsed: boolean;
  onClick: Function;
  pathHasNextStep: boolean;
  pathType: ScriptPathTypesV2 | null;
}

const useStyles = makeStyles((theme) => ({
  container: {
    marginBottom: '-10px',
    marginTop: '-3px',
    paddingTop: theme.spacing(0.5),
    textAlign: 'center',
  },
  button: {
    border: `1px solid ${Colors.GREEN}`,
  },
  buttonSkipped: {
    borderColor: Colors.ORANGE,
  },
  buttonUnresponsive: {
    borderColor: theme.palette.grey[500],
  },
}));

const ScriptStepToggle = ({
  isCollapsed,
  onClick,
  pathHasNextStep,
  pathType,
}: ScriptStepToggleProps) => {
  const styles = useStyles();

  return (
    <div className={styles.container}>
      <IconButton
        size="small"
        onClick={() => onClick()}
        className={cx(styles.button, {
          [styles.buttonSkipped]: pathType === ScriptPathTypesV2.SKIP,
          [styles.buttonUnresponsive]: pathType === ScriptPathTypesV2.UNRESPONSIVE,
        })}
      >
        {pathHasNextStep ? isCollapsed ? <ExpandMoreIcon /> : <ExpandLessIcon /> : <CheckIcon />}
      </IconButton>
    </div>
  );
};

export default ScriptStepToggle;
